import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { DebounceClickDirectiveModule } from 'src/app/directives/debounce-click/debounce-click-directive.module';

import { TableAssignmentSearchStaffModal } from './table-assignment-search-staff.modal';

@NgModule({
  declarations: [TableAssignmentSearchStaffModal],
  imports: [CommonModule, IonicModule, DebounceClickDirectiveModule],
  exports: [TableAssignmentSearchStaffModal]
})
export class TableAssignmentSearchStaffModalModule {}
